import { gql } from "@apollo/client";

const REQUEST_XERO_MUTATION = gql`
  mutation RequestXero($companyId: ID!) {
    requestXero(companyId: $companyId)
  }
`;

export default REQUEST_XERO_MUTATION;
